import React from "react";

const BillboardSupportFooter = () => {
  return (
    <>
      <div className="footer__logo__container mt--4">
        <div className="footer__logo" />
        <div className="footer__logo__name">Beacon Channel Management</div>
      </div>
    </>
  );
};

export default BillboardSupportFooter;
